import type { Compare } from '@festina-life/core'
import { useTranslate } from '@festina-life/ui/hooks'

import type { SubTemplateFieldValue } from '../../types/templateModel'
import { ComparableDocumentationDiff } from './ComparableDocumentationDiff'
import { ConfigurationFieldExpressionValueDiff } from './ConfigurationFieldExpressionValueDiff'
import { DiffEntry } from './DiffEntry'
import { SubTemplateFieldValueParentIdDiff } from './SubTemplateFieldValueParentIdDiff'
import { useCompareContext } from './valueSetupCompareContext'

export const SubTemplateFieldValueDiffContents = ({
  compare,
  current,
}: Compare<SubTemplateFieldValue>) => {
  const translate = useTranslate()
  const { shouldCompare } = useCompareContext()

  return (
    <>
      {current && !compare && (
        <DiffEntry
          title={translate('diffPopover.field.subTemplateVariant')}
          compare="-"
          current={translate('diffPopover.field.creation', {
            name: current.subTemplateIdentifier,
          })}
        />
      )}
      {shouldCompare('variantDocumentation') && (
        <ComparableDocumentationDiff
          current={current?.documentation?.value}
          compare={compare?.documentation?.value}
        />
      )}
      {shouldCompare('parentId') && (
        <SubTemplateFieldValueParentIdDiff
          current={current?.parent?.value}
          compare={compare?.parent?.value}
        />
      )}
      {shouldCompare('defaultSelected') && (
        <ConfigurationFieldExpressionValueDiff
          current={current?.defaultSelected}
          compare={compare?.defaultSelected}
          title={translate('diffPopover.field.defaultSelected')}
        />
      )}
      {shouldCompare('selectable') && (
        <ConfigurationFieldExpressionValueDiff
          current={current?.selectable}
          compare={compare?.selectable}
          title={translate('diffPopover.field.selectable')}
        />
      )}
    </>
  )
}
